import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, SAMPLE_TO_SALE_SCREEN, HOME_TODAY_SCREEN, API_CONSTANTS, COMMON } from '../../global/Constants';
import { S2S_CROP, CROP_GROUP } from '../../global/Enum';
import './sample-to-sale.css';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
//import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import AddCottonHarvest from '../SampleToSale/AddCottonHarvest';
import AddRiceHarvest from './AddRiceHarvest';
import AddMilletHarvest from './AddMilletHarvest';
import AddMustardHarvest from './AddMustardHarvest';
import AddVegHarvest from './AddVegHarvest';
import SyncLoader from '../common/loader/SyncLoader';
import DataProvider from '../../providers/DataProvider';


class AddHarvest extends Component {

    constructor(props) {
        super(props)

        this.state = {
            activity: {}
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.activity;
                if (activity !== undefined && activity !== null) {
                    this.setState({
                        activity: activity
                    });
                }

            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }
    }

    checkVegCrops = () => {
        const { activity } = this.state;
        const crop = DataProvider.getInstance().getCropById(activity.crop_id);
        //Utilities.LogPrint("Crop", crop);
        if (crop?.crop_group_id === CROP_GROUP.VEGETABLE_CROPS) {
            return true;
        } else {
            return false;
        }
    }

    handleBack = () => {
        this.props.history.goBack();
    }

    handleSaveButton = (harvest) => {
        Utilities.LogPrint("Parent", harvest);

        this.setState(prevState => ({
            activity: { ...prevState.activity, harvest: harvest }
        }), () => {
            Utilities.LogPrint("Harvest Obj", this.state.activity);

            if (!this.state.activity?.isEdit) {
                this.props.history.replace({
                    pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
                    state: { activity: this.state.activity }
                });
            } else {
                this.props.history.replace({
                    pathname: ALL_ROUTES.EDIT_SAMPLE_TO_SALE,
                    state: { activity: this.state.activity }
                });
            }

            // this.props.history.replace({
            //     pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
            //     state: { activity: this.state.activity }
            // });
        });
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { activity } = this.state;
        const { isSyncLoading, tableName } = this.state;
        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">

                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <div className="activity-info-box green-activity text-white mb-3 max-w-460">
                                <span>{activity?.activity_tag}</span>
                                <h5>{HOME_TODAY_SCREEN.SAMPLE_TO_SALE} - {SAMPLE_TO_SALE_SCREEN.HARVEST_DETAILS}</h5>
                                <span>{activity?.crop_name + ", " + activity.hybrid_name + " | " + activity.village_name}</span>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-5 col-md-3 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary min-w-182 krishak-cancel-btn" onClick={this.handleBack}>{COMMON.BACK}</button>
                        </div>
                    </div>

                    {activity?.crop_name === S2S_CROP.COTTON ?
                        <AddCottonHarvest activity={activity} handleSaveButton={this.handleSaveButton} /> : null
                    }

                    {activity?.crop_name === S2S_CROP.RICE ?
                        <AddRiceHarvest activity={activity} handleSaveButton={this.handleSaveButton} /> : null
                    }

                    {activity?.crop_name === S2S_CROP.MILLET ?
                        <AddMilletHarvest activity={activity} handleSaveButton={this.handleSaveButton} /> : null
                    }

                    {activity?.crop_name === S2S_CROP.MUSTARD ?
                        <AddMustardHarvest activity={activity} handleSaveButton={this.handleSaveButton} /> : null
                    }

                    {this.checkVegCrops() ?
                        <AddVegHarvest activity={activity} handleSaveButton={this.handleSaveButton} /> : null
                    }

                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
            </div>
        )
    }
}

export default withRouter(AddHarvest);